export function writeTemplateString(target, template, args) {
    const body = new DOMParser().parseFromString(template, 'text/html').body;
    writeTemplateElement(target, body, args);
}
export function writeTemplateElement(target, source, args) {
    for (let i = 0; i < source.childNodes.length; i++) {
        const e = source.childNodes.item(i);
        switch (e.nodeType) {
            case Node.TEXT_NODE:
                target.appendChild(document.createTextNode(e.textContent));
                break;
            case Node.ELEMENT_NODE: {
                const htmlElement = e;
                const tag = htmlElement.tagName.toLowerCase();
                if (args[tag]) {
                    const replacement = args[tag];
                    replacement.append(target, htmlElement);
                }
                else {
                    const newNode = htmlElement.cloneNode(false);
                    target.appendChild(newNode);
                    if (source.hasChildNodes()) {
                        writeTemplateElement(newNode, htmlElement, args);
                    }
                }
                break;
            }
        }
    }
}
